export const notFoundRoute = () => '/404'
